// @flow

import React from 'react';

import { formatDeadlineDates, formatDeadlineTime } from 'client/utils/enrollmentPeriods';
import { getLinkToInterpolate } from 'client/utils/format';

import { DEADLINE_TRANSLATE_PREFIX } from 'routes/cart/components/deadline/DeadlineWarning';
import { StyledDeadlineTranslate } from 'routes/cart/components/shared';
import MissedOepCutoffWarning from 'routes/cart/components/deadline/MissedOepCutoffWarning';

import type { CartDeadlineTranslationsType } from 'routes/cart/types';

type Props = {
  carrierName: string,
  effectiveDate: Date,
  isFFM: boolean,
  isPeriodEnd: boolean,
  nextEffectiveDate: Date,
  officialEndDate: Date,
  onExchange: boolean,
  stateExchange: {
    name: string,
    websiteUrl: string,
  },
  translations: CartDeadlineTranslationsType,
  stateName: string,
};

const MissedCutoffWarning = ({
  carrierName,
  effectiveDate,
  isFFM,
  isPeriodEnd,
  nextEffectiveDate,
  officialEndDate,
  onExchange,
  stateExchange,
  stateName,
  translations,
  partnerDisplayName,
}: Props) => {
  const { websiteUrl, name } = stateExchange;
  const { missedCutoffIcon } = translations;
  const using = {
    carrierName,
    exchangeName: getLinkToInterpolate(websiteUrl, name),
    nextStartDate: formatDeadlineDates(nextEffectiveDate),
    officialEndDate: formatDeadlineDates(officialEndDate),
    officialEndTime: formatDeadlineTime(officialEndDate),
    startDate: formatDeadlineDates(effectiveDate),
    stateName,
    partnerName: partnerDisplayName,
  };

  return (
    <React.Fragment>
      {!isFFM && missedCutoffIcon && (
        <div className="pad-y">
          <img alt="missedCutoff" src={missedCutoffIcon.file.url} />
        </div>
      )}
      {!isPeriodEnd ? (
        <StyledDeadlineTranslate
          path={`${DEADLINE_TRANSLATE_PREFIX}.${
            onExchange ? 'missedCutoffOnExchange' : 'missedCutoffOffExchange'
          }`}
          using={using} />
      ) : (
        <MissedOepCutoffWarning isFFM={isFFM} onExchange={onExchange} using={using} />
      )}
    </React.Fragment>
  );
};

export default MissedCutoffWarning;
